import normalizeDateString from "../common/normalizeDateString";
import { handleCauseDelete } from "../causes/handleCauseDelete";
import { flushSync } from "react-dom";

export default async function handleDeleteMoodForSelectedDate(
  causes,
  selectingMood,
  feelingNames,
  selectedDate,
  customDate,
  moods,
  userId,
  setMoods,
  setRelevantMoods,
  setSelectingMood,
  setDisplayedText,
  navigate,
  setCauses
) {
  // Function called successfully

  console.log("handleDeleteMood ->");
  if (selectingMood === null) {
    console.log("🗑️ DELETE DEBUG: selectingMood is null, returning early");
    return;
  }

  const moodInEnglish = feelingNames[selectingMood];

  console.log("enml " + JSON.stringify(feelingNames));
  console.log("slmd " + selectingMood);
  console.log("deleltedebug2");

  // Derive correct date based on selection
  const targetDate = selectedDate;

  const normalizedTargetDate = normalizeDateString(targetDate);

  // Find mood to delete based on exact mood/date/user
  console.log("🗑️ DELETE DEBUG: Looking for mood to delete:");
  console.log("  - moodInEnglish:", moodInEnglish);
  console.log("  - userId:", userId);
  console.log("  - normalizedTargetDate:", normalizedTargetDate);
  console.log("moods " + JSON.stringify(moods));

  const moodToDelete = moods.find((m) => {
    const moodNormalizedDate = normalizeDateString(m.timestamp);
    console.log(
      `🗑️ DELETE DEBUG: Checking mood ${m.id}: ${moodNormalizedDate} vs ${normalizedTargetDate}`
    );

    return (
      m.uid === userId &&
      m.mood === moodInEnglish &&
      moodNormalizedDate === normalizedTargetDate
    );
  });

  console.log(
    "🗑️ DELETE DEBUG: Found mood to delete:",
    moodToDelete?.id || "NONE"
  );

  if (!moodToDelete?.id) {
    console.warn(
      `🗑️ DELETE DEBUG: No mood entry found for ${normalizedTargetDate} to delete.`
    );
    return;
  }

  console.log("causes to delete -> " + causes.length);
  console.log("causes to delete -> " + JSON.stringify(causes));

  // Delete only causes linked to this mood
  try {
    const linkedCauses = (causes || []).filter(
      (c) => c.moodId === moodToDelete.id
    );
    for (const cause of linkedCauses) {
      await handleCauseDelete(cause, setCauses, userId);
    }
  } catch (e) {
    console.error("Failed to delete linked causes:", e);
  }

  try {
    // Use offline-first data service for deleting mood
    const { default: offlineFirstDataService } =
      await import("../../services/FeelingService");

    const result = await offlineFirstDataService.deleteMood(
      moodToDelete.id,
      userId
    );

    if (!result.success) {
      throw new Error(result.error || "Failed to delete mood");
    }

    console.log("🗑️ DELETE DEBUG: Firebase deletion successful");
    console.log("🗑️ DELETE DEBUG: Updating local state...");
    console.log(
      "🗑️ DELETE DEBUG: Current moods before update:",
      JSON.stringify(moods)
    );
    console.log("🗑️ DELETE DEBUG: Mood ID to delete:", moodToDelete.id);

    // Use flushSync to ensure the state update is synchronous
    flushSync(() => {
      setMoods((prev) => {
        console.log("🗑️ DELETE DEBUG: setMoods callback called");
        console.log("🗑️ DELETE DEBUG: prev array:", JSON.stringify(prev));
        console.log("🗑️ DELETE DEBUG: prev array length:", prev?.length);

        const filtered = prev.filter((m) => {
          const shouldKeep = m.id !== moodToDelete.id;
          console.log(
            `🗑️ DELETE DEBUG: Mood ${m.id}: ${shouldKeep ? "KEEP" : "REMOVE"}`
          );
          return shouldKeep;
        });

        console.log(
          "🗑️ DELETE DEBUG: Filtered result:",
          JSON.stringify(filtered)
        );
        console.log(
          "🗑️ DELETE DEBUG: Filtered result length:",
          filtered.length
        );
        console.log(
          "🗑️ DELETE DEBUG: About to return new moods array to context"
        );
        return filtered;
      });
    });

    // Update relevantMoods for components that use local state
    // Components using useRelevantMoods hook will update automatically
    if (setRelevantMoods) {
      setRelevantMoods((prev) => {
        console.log(
          "🗑️ DELETE DEBUG: Updating relevantMoods, removing index:",
          selectingMood
        );
        const updated = { ...prev };
        delete updated[selectingMood];
        return updated;
      });
    }

    setSelectingMood(null);
    setDisplayedText("");

    console.log(
      "🗑️ DELETE DEBUG: State updates completed with flushSync, navigating to home"
    );
  } catch (error) {
    console.error("🗑️ DELETE DEBUG: Error during deletion:", error);
  }

  console.log("🗑️ DELETE DEBUG: Navigating to /app/home");
  navigate("/app/home");
}
